// const API_HOST = 'http://127.0.0.1:8000';
//const API_HOST = 'http://forbesnewbackend.pm';
//const API_HOST = 'https://forbesnewsbackend.pmcommu.in';
const API_HOST = 'https://backend.forbes.news';
const API_VERSION = '/api/';
const API_URL = API_HOST + API_VERSION;

export default API_URL;